import {takeEvery} from 'redux-saga/effects';
import * as ACTION from './constants';
import * as saga from './saga';

export default function*() {
    yield takeEvery(ACTION.FETCH_LOGS.REQUEST, saga.fetchLogs);
    yield takeEvery(ACTION.FETCH_COMMENTS.REQUEST, saga.fetchComments);
    yield takeEvery(ACTION.COMMENT.REQUEST, saga.comment);
    yield takeEvery(ACTION.COMMENT.FAILED, saga.onCommentFailed);
}